import { IonButton } from '@ionic/react';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { CommentPlusIcon } from '../theme/Icons';
import { useIfLoggedIn } from '../utils/useIfLoggedIn';

const useStyles = createUseStyles({
    button: {
        '--box-shadow': 'none'
    },

    // the same ink as the reaction buttons beside it
    icon: {
        display: 'flex',
        color: 'var(--ion-color-step-750)'
    }
});

export type IAddCommentButtonProps = {
    onClick: () => void;
    authenticatedRedirect: string;
};

export const AddCommentButton: FC<IAddCommentButtonProps> = ({ onClick, authenticatedRedirect }) => {
    const classes = useStyles();

    const ifLoggedIn = useIfLoggedIn();

    const clickHandler = async () => {
        await ifLoggedIn({
            delegate: onClick,
            redirect: authenticatedRedirect,
            message: 'Please sign in or create an account to add comments.',
            trackingFrom: 'Comments'
        });
    };

    return (
        <IonButton
            size="small"
            shape="round"
            color="light"
            onClick={clickHandler}
            className={classes.button}
            data-type="add-comment-btn"
        >
            <div className={classes.icon}>
                <CommentPlusIcon color="inherit" customSize={22} />
            </div>
        </IonButton>
    );
};
